import styled from '@emotion/styled';

export const Wrapper = styled.div<{ open: boolean }>`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background: ${(props) => props.theme.color.medium.default};
  transition: opacity 100ms linear;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 1;
  }
  color: ${(props) => props.theme.color.light.default};
  font-size: 16px;
  cursor: pointer;
  padding: 5px;

  ${(props) =>
    !props.open &&
    `
  visibility: hidden;
  `}
`;
